/**
 * Query-key roots used across Dashboard V2 React Query hooks.
 * Every useQuery key starts with one of these values.
 * Using an enum gives:
 *   - one place to rename
 *   - type-safe refresh invalidation
 *   - no magic string drift between hook + page
 */
export enum DashboardQueryKey {
  STATIONS = 'stations',
  TRANSACTIONS = 'transactions',
  SESSIONS = 'sessions',
  USERS = 'users',
  DASHBOARD_STATS = 'dashboardStats',
  DASHBOARD_KWH_PER_DAY = 'dashboardKwhPerDay',
  STATION_OPTIONS = 'stationOptions',
  NOTIFICATIONS = 'notifications',
  NOTIFICATIONS_UNREAD_COUNT = 'notifications-unread-count',
  ROLES = 'roles',
  PERMISSIONS = 'permissions',
  STATION_REQUESTS = 'stationRequests',
  SETTINGS = 'settings',
  SETTINGS_PUBLIC = 'settingsPublic',
  NOTIFICATION_SETTINGS = 'notificationSettings',
  ORGANIZATIONS = 'organizations',
  MY_ORGANIZATION = 'myOrganization',
  ORGANIZATION_STATIONS = 'organizationStations',
  ORGANIZATION_TEAM = 'organizationTeam',
  PREMIUMS = 'premiums',
  MY_STATION_PRICE = 'myStationPrice',
  SUPPORT_TICKETS = 'supportTickets',
  SUPPORT_TICKET = 'supportTicket',
  SUPPORT_KB_SOURCES = 'supportKbSources',
  SYSTEM_MIGRATIONS = 'systemMigrations',
  SYSTEM_RUNS = 'systemRuns',
  SYSTEM_BACKUPS = 'systemBackups',
  SYSTEM_DATABASE = 'systemDatabase',
}
